import {
  AfterViewInit,
  Directive,
  ElementRef,
  Input,
  Renderer2,
} from '@angular/core';

@Directive({
  selector: '[medDynamicTooltip]',
})
export class MedTooltipDisabledDirective implements AfterViewInit {
  @Input() medDynamicTooltip = '';

  constructor(private renderer: Renderer2,
    private elementRef: ElementRef,
  ) { }

  ngAfterViewInit(): void {
    let counter = 1;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const wnd = window as any;
    const interval = wnd.setInterval(() => {
      const tooltipElement = this.elementRef.nativeElement;
      const containerElement = tooltipElement.parentElement;
      const targetElement = containerElement?.querySelector(`#${this.medDynamicTooltip}`);

      if (tooltipElement && targetElement) {
        const displayStyle = getComputedStyle(targetElement).display;
        if (displayStyle === 'block' &&
          targetElement.offsetWidth >= targetElement.scrollWidth) {
          this.renderer.setAttribute(tooltipElement, 'disabled', 'true');
        } else {
          this.renderer.removeAttribute(tooltipElement, 'disabled');
          if (interval) wnd.clearInterval(interval);
        }
      }
      if (counter > 3) {
        if (interval) wnd.clearInterval(interval);
      }
      counter++;
    }, 100);
  }
}
